import type { TickerCellData } from '../components/CustomCell/Ticker/types';
import type { Row } from '../components/Table';

export const getTickerData = (transactionRow: Row): Partial<TickerCellData> => {
  const {
    ticker: { exchangeCode, symbol, companyName },
    currencyISO,
  } = transactionRow;

  const uniqueSymbol =
    exchangeCode && symbol ? `${exchangeCode}:${symbol}` : null;

  return {
    value: uniqueSymbol,
    name: companyName,
    status: 'success',
    uniqueSymbol,
    currencyISO,
  };
};
